import React from 'react';
import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  SUB_PANEL_WIDTH,
  SUB_PANEL_WIDTH_SX,
  usePortrait,
  handleEnterOrSpace,
} from '../../../staticComponents/StaticHtmlGenerator';

// Define the props interface
interface CloseRightNavPanelProps {
  closeSubPanel: () => void; // Function to close the subpanel
}

const CloseRightNavPanel: React.FC<CloseRightNavPanelProps> = ({ closeSubPanel }) => {
  const portrait = usePortrait();
  return (
    <Box
      id="close-button"
      sx={{
        position: 'absolute',
        right: {
          xs: portrait ? SUB_PANEL_WIDTH_SX : SUB_PANEL_WIDTH,
          md: 351,
        },
        top: {
          xs: portrait ? 24 : 34,
          md: 34,
        },
        width: 29,
        height: 40,
        backgroundColor: '#F2F2F2',
        borderRadius: '8px 0 0 8px',
        padding: '0',
        cursor: 'pointer',
        '&:hover': {
          color: '#AF2007',
        },
      }}
      onClick={closeSubPanel}
      role="button"
      aria-label="Close subpanel"
      tabIndex={0}
      onKeyDown={(e) => handleEnterOrSpace(e, closeSubPanel)}
    >
      <CloseIcon sx={{ marginTop: '7px', marginLeft: '1px' }} />
    </Box>
  );
};

export default CloseRightNavPanel;
